import './_zipcode-search.scss';
import component from './zipcode-search';

export default component;
